import { createSlice } from "@reduxjs/toolkit";
import { getStoredLanguage, normalizeLanguageCode } from "../../utils/language";

const languageSlice = createSlice({
  name: "language",
  initialState: { value: getStoredLanguage() },
  reducers: {
    setLanguage: (state, action) => {
      const language = normalizeLanguageCode(action.payload);

      localStorage.setItem("language", language);
      state.value = language;
    },
  },
});


export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
